import "./home.css";
import Codingba from "../Assets/Codingba.png";
import Element from "../Assets/Element.png";

import Services from "../Services/Services";
import Works from "../../Works/Works";
import About from "../About/About";
import Skills from "../Skills/Skills";
import Contact from "../Contact/Contact";
import FooterNav from "../Nav/FooterNav";
import { Typewriter } from 'typewriting-react';

function Home(props) {
  return (
    <>
      <helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link
          href="https://fonts.googleapis.com/css2?family=Bungee+Inline&family=Montserrat:wght@300;700&family=Oswald:wght@700&display=swap"
          rel="stylesheet"
        />
      </helmet>
      <div className="home" id="Home">
        <section className="about">
          <span className="hi">Hello! I'm</span>
          <span className="name">Boateng Oduro Kelvin</span>
          <span className="prof">
            I'm a Software Developer {'&'} <br/>
           <Typewriter className="cursor" words={['  Graphic Designer','  Video Editor',' UX Designer','Content Creator']} />
           
          </span>
          <button onClick={()=>window.location.assign("tel:00233257307607")}>GET IN TOUCH</button>
          <section className="others">
            <section className="mouse">
              <section className="mousetrack"></section>
            </section>

            <section className="arts">
              <span className="number">478</span>
              <span className="text">Happy Clients</span>
            </section>

            <section className="arts">
              <span className="number">3+</span>
              <span className="text">Years of Experience</span>
            </section>
          </section>
        </section>

        <section className="img" data-aos="zoom-in">
          <section className="overlay"></section>
          <img src={Codingba} alt="Coding Ba " />
          <div className="rect"></div>
          <div className="tri"></div>
        </section>

        <img src={Element} alt="" className="ele" />
        <img src={Element} alt="" className="eles" />
      </div>

      <Services />
      <Works />
      <About />
      <Skills />
      <Contact />
      <FooterNav />
    </>
  );
}

export default Home;
